export default {"src":"/_next/static/media/linkedin-orig.d6a9b280.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};